module.exports = __webpack_public_path__ + "static/media/iros20212.d10e3043.png";